module.exports = __webpack_public_path__ + "static/img/bottom_erweima.955a0a59.png";